import React from "react";
import defaultStoreImage from './assets/images/big-save-store.jpg';

function renderWithLink(googleMapsLink, content) {
  return <a href={googleMapsLink} target="_default">
    {content}
  </a>
}

const StoreTile = ({ store, useGoogleMapsLink }) => {
  const fallbackSrc = defaultStoreImage; // Your fallback image path

  const handleImageError = (e) => {
    e.target.onerror = null; // Prevent infinite loop if fallback also fails
    e.target.src = fallbackSrc;
  };

  let content = <>
      <img
        src={store.imageUrl}
        alt={`${store.name} exterior`}
        className="store-image"
        onError={handleImageError}
      />
      <div className="store-info">
        <h2 className="store-name">{store.name}</h2>
        <p className="store-address"><strong>{store.address}</strong></p>
        <p className="store-contact">
          Email: {store.email}
        </p>
      </div>
    </>
    
  if((useGoogleMapsLink == null || useGoogleMapsLink== true) && store.googleMapsLink != "") {
    return <div className="store-tile">
      {renderWithLink(store.googleMapsLink, content)}
    </div>
  } else {
    return <div className="store-tile">
      {content}
    </div>
  }
};

export default StoreTile;